<!-- @format -->

<section
	[ngClass]="copyBoxOrientation"
	class="ie-height hmf-mb-l hmf-mb-m-xxl"
	[id]="storyId">
	<div class="image-container">
		<dsg-media
			[altText]="data[0].altText"
			[image]=""
			[mobileImg]=""
			[visualAssets]="data[0].visualAssets"
			[willLazyLoad]="true"
			[itemTitle]="
				data[0].imageTitle || data[0].headline || data[0].subhead || data[0].altText
			"
			[imagePagePosition]="addlData.tagSectionNum">
		</dsg-media>
	</div>
	<div class="copybox-container">
		<div
			class="copybox hmf-mx-m-0 hmf-p-s hmf-px-m-l"
			[ngStyle]="copyBoxStyles"
			[ngClass]="copyBoxClasses">
			<div
				*ngIf="data[0].topIcon && data[0].topIcon !== 'none'"
				class="hmf-mb-xl">
				<svg
					*ngIf="data[0].topIcon === 'tree'"
					width="59"
					height="66"
					viewBox="0 0 59 66"
					fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M33.7929 23.6139V14.3552C34.9226 16.6487 41.4748 28.2008 53.3367 28.2008V14.3552C37.7468 14.3552 30.9686 0 30.9686 0H28.2573C28.2573 0 21.2532 14.3552 5.77627 14.3552V28.2008C17.6381 28.2008 24.1904 16.6487 25.3201 14.3552V23.6139C21.5921 28.7954 13.4582 37.1197 0.466675 37.1197V54.0232C16.6214 54.0232 24.6423 36.61 24.6423 36.61H25.3201V66H33.6799V36.61H34.3577C34.3577 36.61 42.3786 54.0232 58.5333 54.0232V37.1197C45.6547 37.1197 37.6339 28.7954 33.7929 23.6139Z"
						fill="white" />
				</svg>
				<svg
					*ngIf="data[0].topIcon === 'flowers'"
					width="110"
					height="66"
					viewBox="0 0 110 66"
					fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M76.2165 66L77.1072 66C77.1072 66 85.1234 51.475 100.958 51.475L100.958 37.4635C87.3996 37.4635 76.7113 51.8418 76.7113 51.8418L76.4144 51.8418C76.4144 51.8418 65.7262 37.4635 52.168 37.4635L52.168 51.475C68.2003 51.475 76.2165 66 76.2165 66Z"
						fill="white" />
					<path
						d="M87.9462 27.3568C87.9462 29.3812 86.8399 31.3774 84.7262 32.9389C82.6131 34.5001 79.5987 35.526 76.1817 35.526C72.7647 35.526 69.7503 34.5001 67.6372 32.9389C65.5236 31.3774 64.4172 29.3812 64.4172 27.3568C64.4172 25.3323 65.5236 23.3362 67.6372 21.7746C69.7503 20.2134 72.7647 19.1875 76.1817 19.1875C79.5987 19.1875 82.6131 20.2134 84.7262 21.7746C86.8399 23.3362 87.9462 25.3323 87.9462 27.3568Z"
						fill="white"
						stroke="white"
						stroke-width="4" />
					<path
						d="M33.2177 49.7292L34.1084 49.7292C34.1084 49.7292 42.1246 35.2042 57.959 35.2042L57.959 21.1927C44.4008 21.1927 33.7126 35.571 33.7126 35.571L33.4157 35.571C33.4157 35.571 22.7274 21.1927 9.16924 21.1927L9.16924 35.2042C25.2016 35.2042 33.2177 49.7292 33.2177 49.7292Z"
						fill="white" />
					<path
						d="M44.9474 11.086C44.9474 13.1104 43.8411 15.1065 41.7274 16.6681C39.6143 18.2293 36.5999 19.2552 33.1829 19.2552C29.7659 19.2552 26.7515 18.2293 24.6384 16.6681C22.5248 15.1065 21.4185 13.1104 21.4185 11.086C21.4185 9.0615 22.5248 7.06537 24.6384 5.5038C26.7515 3.94263 29.7659 2.91669 33.1829 2.91669C36.5999 2.91669 39.6143 3.94263 41.7274 5.5038C43.8411 7.06537 44.9474 9.0615 44.9474 11.086Z"
						fill="white"
						stroke="white"
						stroke-width="4" />
				</svg>
			</div>
			<engage-badge
				*ngIf="displayBadge"
				[data]="data[0].badge">
			</engage-badge>
			<div
				*ngIf="data[0].headline"
				class="headline"
				[ngClass]="headlineClasses">
				{{ data[0].headline }}
			</div>
			<div
				*ngIf="data[0].subhead"
				class="subhead"
				[ngClass]="subheadlineClasses">
				{{ data[0].subhead }}
			</div>
			<div
				*ngIf="data[0].subCopy"
				class="subcopy">
				{{ data[0].subCopy }}
			</div>
			<div
				*ngIf="displayConnectSidePanel || displayCTAS"
				class="cta-container hmf-mt-l"
				[ngClass]="data[0].ctaAlignment || 'align-cta-center'">
				<shared-component-exclusive-product-panel
					*ngIf="displayConnectSidePanel"
					[brand]="connectSidePanelData.connectSidePanelBrand"
					[ctaType]="connectSidePanelCtaType"
					[buttonText]="connectSidePanelData.linkTitle"
					[hasStickyBanner]="connectSidePanelData.stickyCTA"
					[mobileOnlyStickyBanner]="true"></shared-component-exclusive-product-panel>
				<!-- show normal CTA if authenticated and Nike Connected -->
				<ng-container *ngIf="displayCTAS">
					<a
						class="hmf-mb-s"
						*ngFor="let cta of data[0].cta; let i = index"
						hmf-button
						height="base"
						[variant]="data[0].buttonStyle || 'secondary'"
						[href]="cta.link"
						[attr.altText]="cta.linkTitle"
						[attr.target]="targetService(cta.link)"
						[attr.aria-label]="cta.title"
						[dataEm]="
							createTag(i + 1, cta.linkTitle, data[0].headline || data[0].subhead)
						"
						[text]="cta.linkTitle"></a>
				</ng-container>
			</div>
		</div>
	</div>
</section>
